export default () => {
  const revealThumbsElements = document.querySelectorAll('[data-reveal-thumbs]');

  if (revealThumbsElements.length === 0) {
    return;
  }

  revealThumbsElements.forEach((revealThumbsElement) => {
    const setSize = parseInt(revealThumbsElement.dataset.revealThumbs);
    const children = revealThumbsElement.children;
    const numChildren = children.length;

    if (numChildren < setSize) {
      revealThumbsElement.nextElementSibling.style.display = 'none';
      return;
    }

    for (let i = setSize; i < numChildren; i++) {
      children[i].classList.add('hide');
    }

    console.log('num item:', numChildren);
  });

  document.addEventListener('click', (e) => {
    const target = e.target;
    if (target && target.matches('[data-reveal-more]')) {
      const container = target.previousElementSibling;
      const setSize = parseInt(container.dataset.revealThumbs);
      const hiddenItems = container.querySelectorAll('.hide');

      if (hiddenItems.length <= setSize) {
        target.style.display = 'none';
      }

      for (let i = 0; i < setSize && i < hiddenItems.length; i++) {
        hiddenItems[i].classList.remove('hide');
      }

      window.dispatchEvent(new Event('resize'));
    }
  });
};
